import { AbstractControl, ValidationErrors } from '@angular/forms';
export class PasswordValidators {
    static complexityValidator(control: AbstractControl): ValidationErrors | null {
        const value: string = control.value;
         if (!value) {
            return null;
        }
        const hasUpperCase = /[A-Z]/.test(value);
        const hasLowerCase = /[a-z]/.test(value);
        const hasNumeric = /[0-9]/.test(value);
        const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(value);
        const minLength = value.length >= 8;
           if (hasUpperCase && hasLowerCase && hasNumeric && hasSpecialChar && minLength) {
            return null;
        }
        return {
            passwordComplexity: {
                missing: {
                    upperCase: !hasUpperCase,
                    lowerCase: !hasLowerCase,
                    numeric: !hasNumeric,
                    specialChar: !hasSpecialChar,
                    minLength: !minLength
                }
            }
        };
    }
}